import React, { Component } from 'react';

class HospitalReports extends Component {

    render() {
        return (
            <div id="tabPage" style={{ height: '430px' }}>
                <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div><br/><br/><br/><br/><br/><br/>
                        <form href='' style={{ height: '200px', background: 'white' }} 
                        Align='center'>
                            <div className='form' style={{ padding: '19px' }} >
                                <img src="./assets/images/warn.svg" alt="" height="50px" width="50px" />
                                <br /><br />
                                <label style={{ fontSize: '20px' }}>
                                  Work In Progress...
                                </label><br />

                            </div>
                        </form>
                    </div>

                </div>
            </div>
        );
    }
}
export default HospitalReports;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/HospitalReports.js